// import React, { useState, useEffect } from "react";
// import "./TestReportCard.css";
// import TableCompoenent from "../components/TableCompoenent";
// import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import Swal from "sweetalert2";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

// const TestReportCard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { state: routerState } = useRouterLocation();
//   // const { dataClient } = routerState || {};
//   console.log(fetchCourseData);
//   // console.log(fetchCourseData)
//   // console.log("TestReportCard",dataClient)

//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   // const [testName]

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//   });

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const fetchBatchesByCourse = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batches-by-course/?course_id=${value.course_id}`
//       );
//       const data = await response.json();
//       setBatchData(data);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   useEffect(() => {
//     if (value.course_id) {
//       fetchBatchesByCourse();
//     }
//   }, [value.course_id]);

//   const fetchTestDetailsByBatch = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-assessment-detail-by-batch-id/?batch_id=${value.batch_id}&assessment_type_id=2`
//       );
//       const data = await response.json();
//       setTestNameData(data);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   useEffect(() => {
//     if (value.batch_id) {
//       fetchTestDetailsByBatch();
//     }
//   }, [value.batch_id]);
//   const fetchResultsData = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-result-dictionary-v2/?assessment_id=${value.assessment_id}`
//       );
//       const data = await response.json();
//       console.log("test report", data);

//       if (data.data.length === 0) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//                 No Data: Report data for {value.assessment_name} not found.
//               </span>
//             </div>
//             <div className="messagebox-insider2">
//               <button
//                 className="testreportcard-create-btn"
//                 onClick={() => setIsMessageBoxVisible(false)}
//               >
//                 OKAY
//               </button>
//             </div>
//           </div>
//         );
//       } else {
//         setHeaders(data.data[0]);
//         setResultsData(data.data.slice(1));
//       }

//       setIsColumnDivVisible(true);
//     } catch (error) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error: {error.message}</span>
//           </div>
//           <div className="messagebox-insider2">
//             <button
//               className="testreportcard-create-btn"
//               onClick={() => setIsMessageBoxVisible(false)}
//             >
//               OKAY
//             </button>
//           </div>
//         </div>
//       );

//       setTimeout(function () {
//         setIsMessageBoxVisible(false);
//       }, 9000);

//       setActiveImg(ErrorImg);
//     }
//   };

//   // const fetchResultsData = async () => {
//   //   try {
//   //     const response = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-result-dictionary-v2/?assessment_id=${value.assessment_id}`
//   //     );
//   //     const data = await response.json();
//   //     console.log("test report", data);

//   //     if (data.data.length === 0) {
//   //       Swal.fire({
//   //         title: "No Data",
//   //         text: `Report data for ${value.assessment_name} not found.`,
//   //         icon: "info",
//   //         confirmButtonText: "OK",
//   //       });
//   //     } else {
//   //       setHeaders(data.data[0]);
//   //       setResultsData(data.data.slice(1));
//   //     }

//   //     setIsColumnDivVisible(true);
//   //   } catch (error) {
//   //     Swal.fire({
//   //       title: "Error!",
//   //       text: error.message,
//   //       icon: "error",
//   //       confirmButtonText: "OK",
//   //     });
//   //   }
//   // };

//   const handleApplyOrReset = () => {
//     if (isApplied) {
//       // Reset state
//       setIsApplied(false);
//       setValues({
//         report_title: "",
//         course_id: "",
//         batch_id: "",
//         assessment_id: "",
//         assessment_name: "",
//         description: "",
//       });
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers

//       // Force re-render of dropdowns
//       setResetKey((prevKey) => prevKey + 1);
//     } else {
//       // Apply state
//       setIsApplied(true);
//       fetchResultsData();
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );
//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Test Report Card
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={handleCancel}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter reports. View and manage the list of reports
//           already available or create a new report.
//         </p>

//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDown
//               label="Course"
//               setSelected={(selectedOption) =>
//                 setValues({ ...value, course_id: selectedOption })
//               }
//               options={
//                 coursesdata
//                   ? coursesdata.map((course) => ({
//                       label: course.course_description,
//                       id: course.course_id,
//                     }))
//                   : []
//               }
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDown
//               label="Batch"
//               setSelected={(selectedOption) =>
//                 setValues({ ...value, batch_id: selectedOption })
//               }
//               options={batchData.map((batch) => ({
//                 label: batch.batch_code,
//                 id: batch.batch_id,
//               }))}
//               Height="auto"
//               OverFlow="auto"
//               minheight="300px"
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`test_${resetKey}`}
//           >
//             <DropDown
//               label="Test"
//               setSelected={(selectedOption) => {
//                 const selectedTest = testnamedata.find(
//                   (test) => test.assessment_id === selectedOption
//                 );
//                 setValues({
//                   ...value,
//                   assessment_id: selectedOption,
//                   assessment_name: selectedTest.assessment_name,
//                 });
//               }}
//               options={
//                 testnamedata.length > 0
//                   ? testnamedata.map((test) => ({
//                       label: test.assessment_name,
//                       id: test.assessment_id,
//                     }))
//                   : [{ label: "No tests available", id: "" }]
//               }
//               Height="auto"
//               OverFlow="auto"
//               minheight="300px"
//             />
//           </div>
//         </div>
//         <TableCompoenent
//           headers={headers}
//           data={data}
//           searchPlaceholder="Search by Student Name..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//           testname={testnamedata}
//         />
//       </div>
//       <div></div>
//     </div>
//   );
// };

// export default TestReportCard;










































import { useNavigate } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./TestReportCard.css";
import TableCompoenent from "../components/TableCompoenent";
import DropDown from "../../Reports/DummyReportPage/Dropdown";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { API_BASE_URL } from "../../../Config/Config";
import { useLocation as useRouterLocation } from "react-router-dom";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

const TestReportCard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const { state: routerState } = useRouterLocation();
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [selectedTestId, setSelectedTestId] = useState("");
  const [testnamedata, setTestNameData] = useState([]);
  const [resultsData, setResultsData] = useState([]); // For storing API results
  const [headers, setHeaders] = useState([]); // For storing table headers
  const [isApplied, setIsApplied] = useState(false);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    description: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");

  const fetchBatchesByCourse = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batches-by-course/?course_id=${value.course_id}`
      );
      const data = await response.json();
      setBatchData(data || []); // Ensure data is an array
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (value.course_id) {
      fetchBatchesByCourse();
    }
  }, [value.course_id]);

  const fetchTestDetailsByBatch = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-assessment-detail-by-batch-id/?batch_id=${value.batch_id}&assessment_type_id=2`
      );
      const data = await response.json();
      setTestNameData(data || []); // Ensure data is an array
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (value.batch_id) {
      fetchTestDetailsByBatch();
    }
  }, [value.batch_id]);

  const fetchResultsData = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-result-dictionary-v2/?assessment_id=${value.assessment_id}`
      );
      const data = await response.json();

      // if (data.data.length === 0) {
      if (!data || !Array.isArray(data.data) || data.data.length === 0) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                No Data: Report data for {value.assessment_name} not found.
              </span>
            </div>
            <div className="messagebox-insider2">
              <button
                className="testreportcard-create-btn"
                onClick={() => setIsMessageBoxVisible(false)}
              >
                OK
              </button>
            </div>
          </div>
        );
      } else {
        setHeaders(data.data[0]);
        setResultsData(data.data.slice(1));
      }

      setIsColumnDivVisible(true);
    } catch (error) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error: {error.message}</span>
          </div>
          <div className="messagebox-insider2">
            <button
              className="testreportcard-create-btn"
              onClick={() => setIsMessageBoxVisible(false)}
            >
              OK
            </button>
          </div>
        </div>
      );

      setTimeout(function () {
        setIsMessageBoxVisible(false);
      }, 9000);

      setActiveImg(ErrorImg);
    }
  };

  // const handleApplyOrReset = () => {
  //   if (isApplied) {
  //     // Reset state
  //     setIsApplied(false);
  //     setValues({
  //       report_title: "",
  //       course_id: "",
  //       batch_id: "",
  //       assessment_id: "",
  //       assessment_name: "",
  //       description: "",
  //     });
  //     setResultsData([]); // Clear the table data
  //     setHeaders([]); // Clear the headers

  //     // Force re-render of dropdowns
  //     setResetKey((prevKey) => prevKey + 1);
  //   } else {
  //     // Apply state
  //     setIsApplied(true);
  //     fetchResultsData();
  //   }
  // };

  const handleApplyOrReset = () => {
    if (isApplied) {
      // Reset only the report and table data but keep the selected values
      setIsApplied(false);

      // Clear report related fields, but keep course, batch, and test intact
      setResultsData([]); // Clear the table data
      setHeaders([]); // Clear the headers
      setIsColumnDivVisible(false); // Hide the columns div

      // Do NOT reset the course, batch, and test states
      setValues((prevValues) => ({
        ...prevValues, // Keep course_id, batch_id, assessment_id, and assessment_name intact
        report_title: "", // Reset report title
        description: "", // Reset description
      }));
    } else {
      // Apply state
      setIsApplied(true);
      fetchResultsData();
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  // Ensure batchData is always treated as an array
  const data = (Array.isArray(resultsData) ? resultsData : []).map((student) =>
    headers.map((header, index) => student[index])
  );

  // const handleCancel = () => {
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Are you sure you want to cancel?</span>
  //       </div>
  //       <div className="messagebox-insider2">
  //         <button
  //           className="messagebox-cancel-btn"
  //           style={{ marginRight: "10px" }}
  //           onClick={() => setIsMessageBoxVisible(false)}
  //         >
  //           CANCEL
  //         </button>
  //         <button
  //           className="testreportcard-create-btn"
  //           onClick={() => window.location.reload()}
  //         >
  //           PROCEED
  //         </button>
  //       </div>
  //     </div>
  //   );

  //   setTimeout(function () {
  //     setIsMessageBoxVisible(false);
  //   }, 9000);

  //   setActiveImg(InterogativeImg);
  // };

  const course = coursesdata && coursesdata.length > 0
    ? coursesdata.find((course) => course.course_id === selectedCourseId)?.course_description || ""
    : "";

  const batch = batchData && batchData.length > 0
    // ? batchData.find((batch) => batch.batch_id === selectedBatchId)?.batch_code || ""
    ? batchData.find((batch) => batch.batch_id === selectedBatchId)?.batch_name || ""
    : "";

  const testName = testnamedata && testnamedata.length > 0
    ? testnamedata.find((test) => test.assessment_id === selectedTestId)?.assessment_name || ""
    : "";

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span style={{ color: "#2F2E40", fontSize: "30px", textTransform: "capitalize" }}>
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              // onClick={handleCancel}
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter reports. View and manage the list of reports
          already available or create a new report.
        </p>

        <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            {/* <DropDown
              label="Course"
              setSelected={(selectedOption) =>
                setValues({ ...value, course_id: selectedOption })
              }
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      label: course.course_description,
                      id: course.course_id,
                    }))
                  : []
              }
            /> */}
            {/* <DropDown
              label="Course"
              selected={value.course_id} // Set selected value from state
              setSelected={(selectedOption) => {
                setSelectedCourseId(selectedOption);
                setValues({ ...value, course_id: selectedOption });
              }}
              options={coursesdata ? coursesdata.map((course) => ({
                label: course.course_description,
                id: course.course_id,
              })) : []}
            /> */}
            <DropDown
              label="Course"
              selected={value.course_id} // Pass the selected course ID
              setSelected={(selectedOption) => {
                setSelectedCourseId(selectedOption);
                setValues({
                  ...value,
                  course_id: selectedOption,
                  batch_id: "", // Reset batch
                  assessment_id: "", // Reset test
                });
                setResetKey((prevKey) => prevKey + 1); // Force reset of batch and test dropdowns
              }}
              options={
                coursesdata && coursesdata.length > 0 // Add a check for coursesdata
                  ? coursesdata.map((course) => ({
                    label: course.course_description,
                    id: course.course_id,
                  }))
                  : [] // Fallback to an empty array if coursesdata is null or empty
              }
              isRequired="true"
            />

          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            {/* <DropDown
              label="Batch"
              setSelected={(selectedOption) =>
                setValues({ ...value, batch_id: selectedOption })
              }
              options={(Array.isArray(batchData) ? batchData : []).map((batch) => ({
                label: batch.batch_code,
                id: batch.batch_id,
              }))}
              Height="auto"
              OverFlow="auto"
              minheight="300px"
            /> */}
            <DropDown
              label="Batch"
              selected={value.batch_id} // Set selected value from state
              setSelected={(selectedOption) => {
                setSelectedBatchId(selectedOption);
                setValues({ ...value, batch_id: selectedOption });
              }}
              options={Array.isArray(batchData) ? batchData.map((batch) => ({
                // label: batch.batch_code,
                label: batch.batch_name,
                id: batch.batch_id,
              })) : []}
              isRequired="true"
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`test_${resetKey}`}
          >
            {/* <DropDown
              label="Test"
              setSelected={(selectedOption) => {
                const selectedTest = testnamedata.find(
                  (test) => test.assessment_id === selectedOption
                );
                setValues({
                  ...value,
                  assessment_id: selectedOption,
                  assessment_name: selectedTest.assessment_name,
                });
              }}
              options={
                testnamedata.length > 0
                  ? testnamedata.map((test) => ({
                    label: test.assessment_name,
                    id: test.assessment_id,
                  }))
                  : [{ label: "No tests available", id: "" }]
              }
              Height="auto"
              OverFlow="auto"
              minheight="300px"
            /> */}
            <DropDown
              label="Test"
              selected={value.assessment_id} // Set selected value from state
              setSelected={(selectedOption) => {
                const selectedTest = Array.isArray(testnamedata)
                  ? testnamedata.find((test) => test.assessment_id === selectedOption)
                  : null;
                setSelectedTestId(selectedOption);
                setValues({
                  ...value,
                  assessment_id: selectedOption,
                  assessment_name: selectedTest?.assessment_name || "",
                });
              }}
              options={
                Array.isArray(testnamedata) && testnamedata.length > 0
                  ? testnamedata.map((test) => ({
                    label: test.assessment_name,
                    id: test.assessment_id,
                  }))
                  : [{ label: "No Tests Available", id: "" }]
              }
              Height="auto"
              OverFlow="auto"
              minheight="300px"
              isRequired="true"
            />
          </div>
        </div>
        <TableCompoenent
          headers={headers}
          data={data}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          testname={testnamedata}
          ReportPageHeader="Test Report Card"
          course={course}
          batch={batch}
          test={testName}
        />
      </div>
      <div></div>
    </div>
  );
};

export default TestReportCard;
